/* eslint-disable no-useless-escape */

const EMAIL =
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*(\.[a-z]{2,60})$/;

const NUMBER = /^[0-9]+$/;

// 입력할 수 없는 유형의 문자열이 포함되어 있습니다.
const NO_SPECIAL_CHARACTER = /^[^\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&₩\\\=\(\'\"]+$/;

const EMOJI = /\p{Emoji_Presentation}/u;

// 입력할 수 없는 유형의 문자열이 포함되어 있습니다.
const NO_EMOJI = /^(?![\s\S]*\p{Emoji_Presentation})[\s\S]*$/u;

const NO_NEW_LINE = /^(?!.*\r\n).*$/;

// 연속된 하이픈(-)은 사용할 수 없습니다.
const NO_DOUBLE_HYPHEN = /^(?!.*[-]{2}).*$/;

// 연속된 언더바(_)은 사용할 수 없습니다.
const NO_DOUBLE_UNDERBAR = /^(?!.*[_]{2}).*$/;

// 국문과 공백은 입력할 수 없습니다.
const NO_KOREAN = /^[^\s\u3131-\u3163\uAC00-\uD7A3]+$/;

// 공백을 입력할 수 없습니다.
const NO_SPACE = /^[^\s]+$/;

// 첫 글자는 영문 소문자만 가능합니다.
const FIRST_LETTER_LOWER_ALPHA = /^[a-z]/;

// 마지막 글자는 영문 소문자, 숫자만 가능합니다.
const LAST_LETTER_LOWER_ALPHA_DIGIT = /^(.*[a-z0-9])$/;

// 영문 소문자를 1개 이상 포함해야 합니다.
const AT_LEAST_ONE_LOWER_ALPHA = /.*[a-z]+.*/;

// 올바른 IP 형식으로 입력해 주세요.
const IP_PATTERN = /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/;

// 올바른 IP CIDR 형식으로 입력해 주세요.
const IP_CIDR_PATTERN =
  /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/(3[0-2]|[1-2][0-9]|[0-9]))$/;

// 공백 없이 영문 소문자, 숫자, 하이픈(-)만 입력 가능합니다. ({{min}}~{{max}}자)
const getNamePattern = (min: number, max: number) => {
  return new RegExp(`^[a-z]([a-z0-9-]{${min - 2},${max - 2}})[a-z0-9]$`);
};

export {
  EMAIL,
  NUMBER,
  NO_DOUBLE_HYPHEN,
  NO_EMOJI,
  NO_KOREAN,
  NO_SPACE,
  NO_NEW_LINE,
  NO_DOUBLE_UNDERBAR,
  NO_SPECIAL_CHARACTER,
  EMOJI,
  IP_PATTERN,
  IP_CIDR_PATTERN,
  getNamePattern,
  FIRST_LETTER_LOWER_ALPHA,
  LAST_LETTER_LOWER_ALPHA_DIGIT,
  AT_LEAST_ONE_LOWER_ALPHA,
};
